import React from 'react';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { withHydrator } from '@thd-olt-component-react/hydrator';

import { RelatedProductsComponent } from './RelatedProducts/RelatedProductsComponent';
import { RelatedProductsPlaceholder } from './RelatedProducts/RelatedProductsPlaceholder';

const HydratedRelatedProducts = withHydrator({
  id: 'related-products',
  scrollBuffer: 750,
  delay: 2000,
  preserveCtxVal: 'clientStore',
  placeholder: (
    <RelatedProductsPlaceholder />
  )
}, RelatedProductsComponent);

const DynamicRelatedProducts = withDynamicComponent(HydratedRelatedProducts);
const RelatedProducts = withErrorBoundary(DynamicRelatedProducts);

RelatedProducts.dataModel = RelatedProductsComponent.dataModel;
RelatedProducts.propTypes = RelatedProductsComponent.propTypes;

export { RelatedProducts };